export default __webpack_public_path__ + "static/media/youth.cceade7f.jpg";